import { useEffect, useState } from 'react';

import { api } from '../lib/apiClient';

/**
 * Resolve a CMS media reference to a URL.
 *
 * ── REACT NEVER BUILDS A STORAGE URL ─────────────────────────────────────────────────
 *
 * A block holds a `mediaAssetId`, never a key and never a URL. The engine's media
 * resolver turns that id into a public URL or a signed one, after authorizing the
 * requester. A client that could assemble a storage URL would have to know the bucket
 * layout, and a client that knows the bucket layout will eventually guess at one.
 *
 * ── IT FAILS TO null, NEVER TO A BROKEN IMAGE ────────────────────────────────────────
 *
 * Object storage is not configured in production yet, so every one of these lookups
 * currently fails — and that is FINE. Returning null lets the caller fall back to the
 * legacy artwork the event already has, which is what every event page does today. A CMS
 * template referencing an unresolvable asset degrades to the existing image rather than
 * blanking a hero, and nothing about page rendering depends on storage existing.
 */
export function useMediaUrl(assetId: string | null | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!assetId) { setUrl(null); return undefined; }
    let cancelled = false;
    api.get<{ url: string | null }>(`/media/${assetId}/url`)
      .then((r) => { if (!cancelled) setUrl(typeof r.url === 'string' ? r.url : null); })
      .catch(() => { if (!cancelled) setUrl(null); });
    return () => { cancelled = true; };
  }, [assetId]);

  return url;
}
